// extracted by mini-css-extract-plugin
export default {"form":"style_form__bTHbw","avatar":"style_avatar__n3VAs","image":"style_image__7admf","text":"style_text__Z2NOs","button":"style_button__zFBi+"};